import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import api  from '../../services/api';


export const useCaseStudyStore = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body) => {
      const res = await api.post("/case-study/create", body);
      return res;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['viewCaseStudy'] });
      queryClient.invalidateQueries({ queryKey: ['viewSubscription'] });
    },
  });

};